export const isElementDisabled = (element: HTMLElement): boolean =>
  element.hasAttribute('disabled') ||
  ('disabled' in element && element.disabled === true)
